var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vueMain", { attrs: { title: _vm.$t("buttons.settings") } }, [
    _c("div", { staticClass: "card" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "nav",
            { staticClass: "col-lg-2 pl-0 pr-0 sidebar hover-bg" },
            [
              _c(
                "b-nav",
                { staticClass: "nav-pills", attrs: { vertical: "" } },
                [
                  _vm.user_is_api_admin
                    ? _c("b-nav-item", { attrs: { to: "Users" } }, [
                        _c("i", { staticClass: "fa fa-users" }),
                        _vm._v(_vm._s(_vm.$t("buttons.users")))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("b-nav-item", { attrs: { to: "Settings", active: "" } }, [
                    _c("i", { staticClass: "fa fa-cog" }),
                    _vm._v(" " + _vm._s(_vm.$t("buttons.settings")))
                  ]),
                  _vm._v(" "),
                  _c("b-nav-item", { on: { click: _vm.logout } }, [
                    _c("i", { staticClass: "fa fa-sign-out" }),
                    _vm._v(" " + _vm._s(_vm.$t("buttons.logout")))
                  ])
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-lg-10 pr-0" }, [
            _c(
              "div",
              { staticClass: "card-header text-center border-bottom-0" },
              [
                _c("h1", { staticClass: "h4" }, [
                  _vm._v(_vm._s(_vm.$t("labels.interface_settings")))
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c(
                "div",
                { staticClass: "form form-lines" },
                [
                  _c("i18n"),
                  _vm._v(" "),
                  _c("kbnav"),
                  _vm._v(" "),
                  _c("color-contrast"),
                  _vm._v(" "),
                  _c("font-size")
                ],
                1
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Settings/Index.vue?vue&type=template&id=78cf057e&
// module id = null
// module chunks = 